// support for Browserify

require('angular-material');
require('./dist/md-data-table');

module.exports = 'md.data.table';



//////////////////
// WEBPACK FOOTER
// ../~/angular-material-data-table/index.js
// module id = 393
// module chunks = 1